module.exports = __webpack_public_path__ + "static/img/fa-solid-900.84de948.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-solid-900.svg
// module id = 48Yc
// module chunks = 0